/** Раздел словаря «app»: каркас (ui/App.tsx), соединение (net/*), HTTP API (lib/api.ts). */
export const app = {
  brand: 'Рыночный стол',
  signingIn: 'Выполняется вход…',
  activeGame: 'Идёт ваш розыгрыш',
  seated: 'Вы сидите за столом',
  backToTable: 'Вернуться за стол',
  'nav.label': 'Разделы',
  'nav.admin': 'Администрирование',
  'nav.lobby': 'Лобби',
  'nav.profile': 'Профиль',
  demo: 'ДЕМО',
  demoMore: '· игровые кредиты · без реальных денег',
  demoTitle: 'Игровые кредиты не имеют денежной стоимости',
  rules: 'Правила',
  theme: 'Сменить тему',
  balanceTitle: 'Баланс игровых кредитов',
  'menu.profile': 'Профиль и история',
  'menu.logout': 'Выйти',
  'conn.connecting': 'Подключение к серверу…',
  'conn.lost': 'Нет связи с сервером — переподключение…',
  'conn.poll': 'резервный HTTP-канал',
  'conn.code': '(код {code})',
  'conn.attempts': ', попыток: {n}.',
  'conn.wsHint': 'Если WebSocket в вашей сети недоступен, клиент сам перейдёт на резервный канал.',
  'conn.pollHint': 'Сервер недоступен и по HTTP — проверьте подключение к сети.',
  noConnection: 'нет соединения с сервером — идёт переподключение',
  'api.offline': 'нет связи с сервером',
  'api.serverError': 'ошибка сервера ({status})',
};
